import s from "./ArticleCTACard.module.scss";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";
import { IconImage } from "@/components/UI/IconImage";
import { Button } from "@/components/UI/Buttons/Button";
import Link from "next/link";

type ArticleCTACardProps = {
  className?: string;
};

export const ArticleCTACard = ({ className }: ArticleCTACardProps) => (
  <div className={cn(cs.cardCTAHover, s.card, className)}>
    <Link href="/tools/readability-checker" className={s.link} />
    <div className={cn(cs.h4, s.heading)}>Worried about writing a unique paper?</div>
    <IconImage size={54} icon="readability-checker" className={s.image} />
    <p className={s.text}>
      Use our free
      <br />
      <strong>Readability checker</strong>
    </p>
    <Button size="fullwidth" href="/tools/readability-checker">
      Check for free
    </Button>
  </div>
);
